import { render } from "./knowledgeLogin.vue?vue&type=template&id=191e55d0&scoped=true"
import script from "./knowledgeLogin.vue?vue&type=script&lang=js"
export * from "./knowledgeLogin.vue?vue&type=script&lang=js"

import "./knowledgeLogin.vue?vue&type=style&index=0&id=191e55d0&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191e55d0"]])

export default __exports__